// Meta Pixel helpers — base code + init lives in public/index.html (single init, single initial PageView)

export function trackPixel(event, params) {
  if (typeof window === "undefined" || typeof window.fbq !== "function") return;
  // Guard against duplicate rapid-fire of the identical event (React StrictMode dev
  // double-effects, accidental double-clicks). Meta also dedupes server-side.
  const key = event + JSON.stringify(params || {});
  const now = Date.now();
  if (key === trackPixel._k && now - trackPixel._t < 800) return;
  trackPixel._k = key;
  trackPixel._t = now;
  if (params) window.fbq("track", event, params);
  else window.fbq("track", event);
}

// Purchase must fire exactly once per order, even if the success page is refreshed
export function trackPurchaseOnce(orderId, params) {
  if (!orderId) return;
  const key = `fb_purchase_${orderId}`;
  try {
    if (localStorage.getItem(key)) return;
    localStorage.setItem(key, "1");
  } catch (err) {
    // storage unavailable (private browsing) — still fire once for this page load
    console.debug("Pixel purchase-dedupe storage unavailable:", err);
  }
  trackPixel("Purchase", params);
}
